import type { IPlainTooltipProps } from "@similarweb/ui-components";
import { PlainTooltip } from "@similarweb/ui-components";
import classNames from "classnames";
import type { ForwardedRef } from "react";
import { forwardRef } from "react";

import { APPEND_SELECTOR, CLOSE_DELAY } from "./const";

type Props = IPlainTooltipProps & {
    className?: string;
};

const InteractiveTooltip = <_, Ref>(props: Props, ref: ForwardedRef<Ref>) => {
    const { children, className, ...rest } = props;

    return (
        <PlainTooltip
            ref={ref}
            appendTo={APPEND_SELECTOR}
            closeDelay={CLOSE_DELAY}
            cssClass={classNames("PlainTooltip-element", className)}
            cssClassContent={classNames("PlainTooltip-content", className)}
            allowHover
            {...rest}
        >
            {children}
        </PlainTooltip>
    );
};

export default forwardRef(InteractiveTooltip);
